import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadCardsAppMobileNudgeComponent } from './download-cards-app-mobile-nudge.component';

@NgModule({
  declarations: [
    DownloadCardsAppMobileNudgeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DownloadCardsAppMobileNudgeComponent
  ]
})
export class DownloadCardsAppMobileNudgeModule { } 